
/**
 * Validate manifest schema
 * @typedef {Object} Manifest
 * @property {string} APP_NAME
 * @property {Array<string>} resolvePropsModules
 * @property {Object} runtimeProps
 */
function validateSchema(manifestToValidate) {
  try {
    if (typeof manifestToValidate !== "object") {
      throw new Error("Invalid manifest");
    }
    const { manifest, resolvePropsModules, runtimeProps } =
      manifestToValidate;

    const { APP_NAME } = manifest;
    const validResolvePropsModules = Array.isArray(resolvePropsModules);

    if (
      !APP_NAME ||
      typeof APP_NAME !== "string" ||
      !validResolvePropsModules ||
      typeof runtimeProps !== "object" 
    ) {
      throw new Error("Manifest invalid schema");
    }

    return true;
  } catch (e) {
    console.error('Error validate schema: ', e);

    return false;
  }
}

module.exports = { validateSchema };
